var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.ready() && _vm.$auth.check('admin'))?_c('div',[_c('nav',{attrs:{"role":"navigation"}},[_c('breadcrumbs'),_c('router-view')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }